<div class="container-fluid py-4">
	<div class="row">
		<div class="col-12">
			<h2 class="mb-4">
				<i class="fa fa-key mr-2"></i>
				{{'password_reveal.page_title' | translate}}
			</h2>
			
			<!-- Tabs -->
			<ul class="nav nav-tabs mb-4" role="tablist">
				<li class="nav-item">
					<a 
						class="nav-link" 
						[class.active]="activeTab === 'site'"
						(click)="setActiveTab('site')"
						role="tab">
						<i class="fa fa-building mr-1"></i>
						{{'password_reveal.site_password_requests' | translate}}
					</a>
				</li>
				<li class="nav-item">
					<a 
						class="nav-link" 
						[class.active]="activeTab === 'device'"
						(click)="setActiveTab('device')"
						role="tab">
						<i class="fa fa-microchip mr-1"></i>
						{{'password_reveal.device_password_requests' | translate}}
					</a>
				</li>
			</ul>

			<!-- Site Password Requests Tab -->
			<div *ngIf="activeTab === 'site'">
				<div class="card">
					<div class="card-body">
						<div *ngIf="siteTableData.length === 0" class="alert alert-info">
							{{'password_reveal.no_requests_found' | translate}}
						</div>

						<sct-custom-table
							*ngIf="siteTableData.length > 0"
							[columnsConfig]="siteColumnConfig"
							[config]="siteTableConfig"
							[data]="siteTableData">
						</sct-custom-table>
					</div>
				</div>
			</div>

			<!-- Device Password Requests Tab -->
			<div *ngIf="activeTab === 'device'">
				<div class="card">
					<div class="card-body">
						<div *ngIf="deviceTableData.length === 0" class="alert alert-info">
							{{'password_reveal.no_requests_found' | translate}}
						</div>
						
						<sct-custom-table
							*ngIf="deviceTableData.length > 0"
							[columnsConfig]="deviceColumnConfig"
							[config]="deviceTableConfig"
							[data]="deviceTableData">
						</sct-custom-table>
					</div>
				</div>
			</div>
		</div>
	</div>

<app-modal #approveConfirmModal title="{{'password_reveal.confirm_approve_title' | translate}}" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div>
		{{'password_reveal.confirm_approve' | translate}}
	</div>
	<div class="modal-footer">
		<button class="btn btn-default mr-2" (click)="approveConfirmModal.hide()">{{'g.cancel' | translate}}</button>
		<button class="btn btn-primary" (click)="confirmApproveRequest()">{{'g.ok' | translate}}</button>
	</div>
</app-modal>

<app-modal #rejectConfirmModal title="{{'password_reveal.confirm_reject_title' | translate}}" [hasConfirmButton]="false" [hasCloseButton]="false">
	<div>
		<p>{{'password_reveal.confirm_reject' | translate}}</p>
		<div class="form-group">
			<label for="rejectReason">
				{{'password_reveal.reject_reason_label' | translate}} <span class="text-danger">*</span>
			</label>
			<textarea 
				id="rejectReason"
				class="form-control" 
				rows="3" 
				[(ngModel)]="rejectReason" 
				placeholder="{{'password_reveal.reject_reason_placeholder' | translate}}"
				maxlength="250"
				required>
			</textarea>
			<small class="form-text text-muted">
				{{rejectReason.length}}/250 {{'password_reveal.characters' | translate}}
			</small>
		</div>
	</div>
	<div class="modal-footer">
		<button class="btn btn-default mr-2" (click)="rejectConfirmModal.hide()">{{'g.cancel' | translate}}</button>
		<button class="btn btn-danger" (click)="confirmRejectRequest()">{{'g.ok' | translate}}</button>
	</div>
</app-modal>
